const translations = {
    en: {
      joinApp: {
        fat: "Create your own quiz in our app",
        text: "and find out how well your friends know you ⬇️"
      },
      privacy: "Privacy",
      terms: "Terms",
      invalidLink: {
        title: "Invalid Quiz Link",
        text: "Check your link or try again with the app."
      },
      incognitoMode: {
        title: "Quiz Feature Blocked",
        text: "Some features may not work in Incognito mode. Try opening the link on normal mode."
      },
      quizCompleted: {
        title: "Quiz Completed",
        text: (name) => `${name} can check your answers in the app.`
      },
      you: "You",
      yourFriend: "Your Friend",
      quizOwner: (name) => `${name}'s Quiz`,
      enterName: {
        title: "What's your name?",
        text: (name) => `Enter your name so ${name} knows these answers are yours.`
      },
      limitReached: {
        title: "Quiz Limit Reached",
        text: (name) => `${name} has reached their friends limit.`
      },
      startDescription: (name) => `How well do you know ${name}?`,
      popupText: "Create your own Quiz in the BondZ App ⬇️",
      createQuiz: {
        short: "Create your quiz",
        long: "Create your own quiz"
      },
      popupFomo: {
        text: (name) => `${name} and many others already created their quiz `,
        fat: "👇 Now it's your turn 👇"
      },
      popupDes: "How well do your friends know you?",
      message1: (name) => `${name} can see your answers in the app 📲`,
      message2: "Keep it going 👏",
      message3: "You're halfway there 🥳",
      message4: "Almost done 👀\nJust 2 more to go!",
      questionCount: (count) => `Question ${count} out of 10`,
      startQuiz: "Start Quiz",
      loadingQuiz: "Loading questions...",
      gameCompleted: {
        title: "Game Completed",
        text: (name) => `Ask ${name} for your result.`
      },
      woy: {
        title: "Who of You?",
        description: (name) => `Play 'Who of You' with ${name}` 
      },
      tel: {
        title: "Emoji Telepathy",
        description: (name) => `Try to pick the same emojis as ${name}` 
      },
      notUnlocked: {
        title: "Game Mode Locked",
        text: (name) => `${name} hasn't unlocked this game mode yet.` 
      },
      startFomo: (name) => `Answer 10 quick questions about ${name} 👇`,
      startFomoCount: (count, name) => `${count} of ${name}'s friends already took this quiz 👇`,
      endFomo: (name) => `Find out how well ${name} and your other friends know you 👇`,
      endFomoFriends: (name) => `Find out how well ${name} and your friends know you 👇`,
      endFomoNoName: "Find out how well your friends know you 👇",
      endFomoGame: "Play this and other games with your friends 👇",
      continuePlaying: "Continue playing",
      cou: {
        title: "Couple Test",
        description: (name) => `You better don't mess this up!` 
      },
      tot: {
        title: "This or That?",
        description: (name) => `How well do you know ${name}?` 
      },
      sib: {
        title: "Siblings Test",
        description: (name) => `How well do you know each other?` 
      },
      playQuiz: "Play Quiz",
      leaderboardSub: (name) => `Who knows ${name} best?`,
      resTitle: (score) => `${score} out of 10 correct`,
      resDes: (name) => `Create your own quiz now.`,
      ranking: "Ranking",
      newQuiz: (name) => `${name} has new questions ❗️`,
      qreslock: "Create your own quiz first to reveal what you got wrong!",
      endFomoBadScore: "Think your friends know you better than this? 👇",
      endFomoGoodScore: "Think your friends know you this well too? 👇",
      endFomoQuestions: "Reveal what questions you got wrong 👀",
      justGuess: "Just guess",
      testYourFriends: "Test your friends",
      resultCopyLink: "Copy this link and paste it in the app to see what questions you got wrong 👇",
      getTheApp: "See your result",
      linkCopied: "Link copied!",
      customHint: (name) => `Question created by ${name}`,
      loadingQuiz: "Loading Quiz...",
      loadingResult: "Loading Result..."
    },
  
    de: {
      joinApp: {
        fat: "Erstelle dein eigenes Quiz in unserer App",
        text: "und finde heraus, wie gut dich deine Freunde kennen ⬇️"
      },
      privacy: "Datenschutzerklärung",
      terms: "AGBs",
      invalidLink: {
        title: "Ungültiger Quiz Link",
        text: "Überprüfe deinen Link oder versuch es mit der App nochmal."
      },
      incognitoMode: {
        title: "Quiz-Funktion blockiert",
        text: "Einige Funktionen funktionieren im Inkognito-Modus möglicherweise nicht. Versuche, den Link im normalen Modus zu öffnen."
      },
      quizCompleted: {
        title: "Quiz abgeschlossen",
        text: (name) => `${name} kann deine Antworten in der App ansehen.`
      },
      you: "Du",
      yourFriend: "Dein Freund",
      quizOwner: (name) => `${name}s Quiz`,
      enterName: {
        title: "Wie heißt du?",
        text: (name) => `Gib deinen Namen ein, damit ${name} weiß, dass diese Antworten von dir sind.`
      },
      limitReached: {
        title: "Quiz-Limit erreicht",
        text: (name) => `${name} hat das Freunde-Limit erreicht.`
      },
      startDescription: (name) => `Wie gut kennst du ${name}?`,
      popupText: "Erstelle dein eigenes Quiz in der BondZ-App ⬇️",
      createQuiz: {
        short: "Erstelle dein Quiz",
        long: "Erstelle dein eigenes Quiz"
      },
      popupFomo: {
        text: (name) => `${name} und viele andere haben schon ihr Quiz erstellt `,
        fat: "👇 Jetzt bist du dran 👇"
      },
      popupDes: "Wie gut kennen dich deine Freunde?",
      message1: (name) => `${name} kann deine Antworten in der App sehen 📲`,
      message2: "Weiter so 👏",
      message3: "Du hast die Hälfte geschafft 🥳",
      message4: "Fast fertig 👀\nNur noch 2!",
      questionCount: (count) => `Frage ${count} von 10`,
      startQuiz: "Quiz starten",
      loadingQuiz: "Fragen werden geladen...",
      gameCompleted: {
        title: "Spiel beendet",
        text: (name) => `Frag ${name} nach deinem Ergebnis.`,
      },
      woy: {
        title: "Wer von euch?",
        description: (name) => `Spiele 'Wer von euch?' mit ${name}`
      },
      tel: {
        title: "Emoji-Telepathie",
        description: (name) => `Versuche, die gleichen Emojis wie ${name} zu wählen`
      },
      notUnlocked: {
        title: "Spielmodus gesperrt",
        text: (name) => `${name} hat diesen Spielmodus noch nicht freigeschaltet.`
      },
      startFomo: (name) => `Beantworte 10 kurze Fragen über ${name} 👇`,
      startFomoCount: (count, name) => `${count} von ${name}s Freunden haben dieses Quiz schon gemacht 👇`,
      endFomo: (name) => `Finde heraus, wie gut ${name} und deine anderen Freunde dich kennen 👇`,
      endFomoFriends: (name) => `Finde heraus, wie gut ${name} und deine Freunde dich kennen 👇`,
      endFomoNoName: "Finde heraus, wie gut deine Freunde dich kennen 👇",
      endFomoGame: "Spiel das und andere Spiele mit deinen Freunden 👇",
      continuePlaying: "Weiterspielen",
      cou: {
        title: "Paar-Test",
        description: (name) => `Du solltest das besser nicht vermasseln!`
      },
      tot: {
        title: "Das oder Das?",
        description: (name) => `Wie gut kennst du ${name}?`
      },
      sib: {
        title: "Geschwister-Test",
        description: (name) => `Wie gut kennt ihr euch?`
      },
      playQuiz: "Quiz spielen",
      leaderboardSub: (name) => `Wer kennt ${name} am besten?`,
      resTitle: (score) => `${score} von 10 richtig`,
      resDes: (name) => `Erstelle jetzt dein eigenes Quiz.`,
      ranking: "Ranking",
      newQuiz: (name) => `${name} hat neue Fragen ❗️`,
      qreslock: "Erstell zuerst dein eigenes Quiz, um zu sehen, was du falsch hattest!",
      endFomoBadScore: "Denkst du, deine Freunde kennen dich besser? 👇",
      endFomoGoodScore: "Denkst du, deine Freunde kennen dich auch so gut? 👇",
      endFomoQuestions: "Sieh, welche Fragen du falsch hattest 👀",
      justGuess: "Rate einfach",
      testYourFriends: "Teste deine Freunde",
      resultCopyLink: "Kopiere diesen Link und füge ihn in der App ein, um zu sehen, welche Fragen du falsch hattest 👇",
      getTheApp: "Erhalte dein Ergebnis",
      linkCopied: "Link kopiert!",
      customHint: (name) => `Frage erstellt von ${name}`,
      loadingQuiz: "Quiz wird geladen...",
      loadingResult: "Ergebnis wird geladen...",
    },
  
    es: {
      joinApp: {
        fat: "Crea tu propio quiz en nuestra aplicación",
        text: "y descubre qué tan bien te conocen tus amigos ⬇️"
      },
      privacy: "Política de privacidad",
      terms: "Términos de servicio",
      invalidLink: {
        title: "Enlace de quiz no válido",
        text: "Revisa tu enlace o inténtalo de nuevo con la aplicación."
      },
      incognitoMode: {
        title: "Función del quiz bloqueada",
        text: "Es posible que algunas funciones no funcionen en modo incógnito. Intenta abrir el enlace en modo normal."
      },
      quizCompleted: {
        title: "Quiz completado",
        text: (name) => `${name} puede revisar tus respuestas en la aplicación.`
      },
      you: "Tú",
      yourFriend: "Tu amigo",
      quizOwner: (name) => `El quiz de ${name}`,
      enterName: {
        title: "¿Cómo te llamas?",
        text: (name) => `Introduce tu nombre para que ${name} sepa que estas respuestas son tuyas.`
      },
      limitReached: {
        title: "Límite de quiz alcanzado",
        text: (name) => `${name} ha alcanzado su límite de amigos.`
      },
      startDescription: (name) => `¿Qué tanto conoces a ${name}?`,
      popupText: "Crea tu propio cuestionario en la app BondZ ⬇️",
      createQuiz: {
        short: "Crea tu quiz",
        long: "Crea tu propio quiz"
      },
      popupFomo: {
        text: (name) => `${name} y muchos más ya han creado su quiz `,
        fat: "👇 Ahora te toca a ti 👇"
      },
      popupDes: "¿Qué tan bien te conocen tus amigos?",
      message1: (name) => `${name} puede ver tus respuestas en la app 📲`,
      message2: "Sigue así 👏",
      message3: "Has terminado la mitad 🥳", 
      message4: "Casi listo 👀\n¡Solo quedan 2 más!",
      questionCount: (count) => `Pregunta ${count} de 10`,
      startQuiz: "Iniciar quiz",
      loadingQuiz: "Cargando preguntas...",
      gameCompleted: {
        title: "Juego completado",
        text: (name) => `Pídele el resultado a ${name}.`
      },
      woy: {
        title: "¿Quién de ustedes?",
        description: (name) => `Juega '¿Quién de ustedes?' con ${name}`
      },
      tel: {
        title: "Telepatía de Emojis",
        description: (name) => `Intenta elegir los mismos emojis que ${name}`
      },
      notUnlocked: {
        title: "Modo de juego bloqueado",
        text: (name) => `${name} no ha desbloqueado este modo de juego aún.`
      },
      startFomo: (name) => `Responde 10 preguntas rápidas sobre ${name} 👇`,
      startFomoCount: (count, name) => `${count} de los amigos de ${name} ya hicieron este quiz 👇`,
      endFomo: (name) => `Descubre qué tan bien ${name} y tus otros amigos te conocen 👇`,
      endFomoFriends: (name) => `Descubre qué tan bien ${name} y tus amigos te conocen 👇`,
      endFomoNoName: "Descubre qué tan bien te conocen tus amigos 👇",
      endFomoGame: "Juega a esto y a otros juegos con tus amigos 👇",
      continuePlaying: "Seguir jugando",
      cou: {
        title: "Test de Pareja",
        description: (name) => `¡Más vale que no arruines esto!`
      },
      tot: {
        title: "¿Esto o Aquello?",
        description: (name) => `¿Qué tanto conoces a ${name}?`
      },
      sib: {
        title: "Test de Hermanos",
        description: (name) => `¿Qué tanto se conocen?`
      },
      playQuiz: "Jugar quiz",
      leaderboardSub: (name) => `¿Quién conoce mejor a ${name}?`,
      resTitle: (score) => `${score} de 10 correctas`,
      resDes: (name) => `Crea tu propio quiz ahora.`,
      ranking: "Clasificación",
      newQuiz: (name) => `${name} tiene nuevas preguntas ❗️`,
      qreslock: "Crea primero tu propio quiz para ver qué fallaste!",
      endFomoBadScore: "¿Crees que tus amigos te conocen mejor? 👇",
      endFomoGoodScore: "¿Crees que tus amigos también te conocen así de bien? 👇",
      endFomoQuestions: "Mira qué preguntas fallaste 👀",
      justGuess: "Solo adivina",
      testYourFriends: "Reta a tus amigos",
      resultCopyLink: "Copia este enlace y pégalo en la app para ver qué preguntas fallaste 👇",
      getTheApp: "Ver resultado",
      linkCopied: "¡Enlace copiado!",
      customHint: (name) => `Pregunta creada por ${name}`,
      loadingQuiz: "Cargando quiz...",
      loadingResult: "Cargando resultado...",
    },
  
    pt: {
      joinApp: {
        fat: "Crie seu próprio quiz em nosso aplicativo",
        text: "e descubra o quanto seus amigos te conhecem ⬇️"
      },
      privacy: "Política de privacidade",
      terms: "Termos de serviço",
      invalidLink: {
        title: "Link de quiz inválido",
        text: "Verifique seu link ou tente novamente no aplicativo."
      },
      incognitoMode: {
        title: "Funcionalidade do quiz bloqueada",
        text: "Algumas funcionalidades podem não funcionar no modo anónimo. Tenta abrir o link no modo normal."
      },
      quizCompleted: {
        title: "Quiz concluído",
        text: (name) => `${name} pode verificar suas respostas no aplicativo.`
      },
      you: "Você",
      yourFriend: "Seu amigo",
      quizOwner: (name) => `Quiz de ${name}`,
      enterName: {
        title: "Qual é o seu nome?",
        text: (name) => `Digite seu nome para que ${name} saiba que estas respostas são suas.`
      },
      limitReached: {
        title: "Limite de quiz atingido",
        text: (name) => `${name} atingiu o limite de amigos.`
      },
      startDescription: (name) => `O quanto você conhece ${name}?`,
      popupText: "Crie seu próprio quiz no app BondZ ⬇️",
      createQuiz: {
        short: "Crie seu quiz",
        long: "Crie seu próprio quiz"
      },
      popupFomo: {
        text: (name) => `${name} e muitos outros já criaram seu quiz `,
        fat: "👇 Agora é a sua vez 👇"
      },
      popupDes: "O quanto seus amigos te conhecem bem?",
      message1: (name) => `${name} pode ver suas respostas no app 📲`,
      message2: "Continue assim 👏",
      message3: "Você terminou a metade 🥳",  
      message4: "Quase lá 👀\nFaltam só mais 2!",
      questionCount: (count) => `Pergunta ${count} de 10`,
      startQuiz: "Iniciar quiz",
      loadingQuiz: "Carregando perguntas...",
      gameCompleted: {
        title: "Jogo concluído",
        text: (name) => `Peça o resultado a ${name}.`
      },
      woy: {
        title: "Quem entre vocês?",
        description: (name) => `Jogue 'Quem entre vocês?' com ${name}`
      },
      tel: {
        title: "Telepatia de Emojis",
        description: (name) => `Tenta escolher os mesmos emojis que ${name}`
      },
      notUnlocked: {
        title: "Modo de jogo bloqueado",
        text: (name) => `${name} ainda não desbloqueou este modo de jogo.`
      },
      startFomo: (name) => `Responda 10 perguntas rápidas sobre ${name} 👇`,
      startFomoCount: (count, name) => `${count} dos amigos de ${name} já fizeram esse quiz 👇`,
      endFomo: (name) => `Descubra o quanto ${name} e seus outros amigos te conhecem 👇`,
      endFomoFriends: (name) => `Descubra o quanto ${name} e seus amigos te conhecem 👇`,
      endFomoNoName: "Descubra o quanto seus amigos te conhecem 👇",
      endFomoGame: "Jogue isso e outros jogos com seus amigos 👇",
      continuePlaying: "Continuar jogando",
      cou: {
        title: "Teste de Casal",
        description: (name) => `É melhor você não estragar isso!`
      },
      tot: {
        title: "Isso ou Aquilo?",
        description: (name) => `O quanto você conhece ${name}?`
      },
      sib: {
        title: "Teste entre Irmãos",
        description: (name) => `O quanto vocês se conhecem?`
      },
      playQuiz: "Jogar quiz",
      leaderboardSub: (name) => `Quem conhece ${name} melhor?`,
      resTitle: (score) => `${score} de 10 corretas`,
      resDes: (name) => `Crie seu próprio quiz agora.`,
      ranking: "Ranking",
      newQuiz: (name) => `${name} tem novas perguntas ❗️`,
      qreslock: "Crie primeiro seu próprio quiz para ver o que errou!",
      endFomoBadScore: "Acha que seus amigos te conhecem melhor? 👇",
      endFomoGoodScore: "Acha que seus amigos também te conhecem tão bem assim? 👇",
      endFomoQuestions: "Veja quais perguntas você errou 👀",
      justGuess: "Apenas adivinhe",
      testYourFriends: "Teste seus amigos",
      resultCopyLink: "Copie este link e cole no app para ver quais perguntas você errou 👇",
      getTheApp: "Ver resultado",
      linkCopied: "Link copiado!",
      customHint: (name) => `Pergunta criada por ${name}`,
      loadingQuiz: "Carregando quiz...",
      loadingResult: "Carregando resultado...",
    },
  
    fr: {
      joinApp: {
        fat: "Crée ton propre quiz dans notre application",
        text: "et découvre à quel point tes amis te connaissent ⬇️"
      },
      privacy: "Politique de confidentialité",
      terms: "Conditions d’utilisation",
      invalidLink: {
        title: "Lien du quiz invalide",
        text: "Vérifie ton lien ou réessaie avec l’application."
      },
      incognitoMode: {
        title: "Fonction du quiz bloquée",
        text: "Certaines fonctionnalités peuvent ne pas fonctionner en mode navigation privée. Essaie d’ouvrir le lien en mode normal."
      },
      quizCompleted: {
        title: "Quiz terminé",
        text: (name) => `${name} peut voir tes réponses et le résultat dans l’application.`
      },
      you: "Toi",
      yourFriend: "Ton ami",
      quizOwner: (name) => `Le quiz de ${name}`,
      enterName: {
        title: "Quel est ton nom ?",
        text: (name) => `Entre ton nom pour que ${name} sache que ces réponses sont les tiennes.`
      },
      limitReached: {
        title: "Limite du quiz atteinte",
        text: (name) => `${name} a atteint sa limite d’amis.`
      },
      startDescription: (name) => `À quel point connais-tu ${name} ?`,
      popupText: "Créez votre propre quiz dans l’application BondZ ⬇️",
      createQuiz: {
        short: "Crée ton quiz",
        long: "Crée ton propre quiz"
      },
      popupFomo: {
        text: (name) => `${name} et beaucoup d’autres ont déjà créé leur quiz `,
        fat: "👇 À ton tour maintenant 👇"
      },
      popupDes: "À quel point tes amis te connaissent-ils bien ?",
      message1: (name) => `${name} peut voir vos réponses dans l'application 📲`,
      message2: "Continue comme ça 👏",
      message3: "Tu as terminé la moitié 🥳",
      message4: "Presque fini 👀\nPlus que 2 à faire !",
      questionCount: (count) => `Question ${count} sur 10`,
      startQuiz: "Démarrer",
      loadingQuiz: "Chargement des questions....",
      gameCompleted: {
        title: "Partie terminée",
        text: (name) => `Demande-lui le résultat.`
      },
      woy: {
        title: "Qui parmi vous ?",
        description: (name) => `Joue à 'Qui parmi vous ?' avec ${name}`
      },
      tel: {
        title: "Télépathie Emoji",
        description: (name) => `Essaie de choisir les mêmes emojis que ${name}`
      },
      notUnlocked: {
        title: "Mode de jeu verrouillé",
        text: (name) => `${name} n’a pas encore débloqué ce mode de jeu.`
      },
      startFomo: (name) => `Réponds à 10 questions rapides sur ${name} 👇`,
      startFomoCount: (count, name) => `${count} des amis de ${name} ont déjà fait ce quiz 👇`,
      endFomo: (name) => `Découvre à quel point ${name} et tes autres amis te connaissent 👇`,
      endFomoFriends: (name) => `Découvre à quel point ${name} et tes amis te connaissent 👇`,
      endFomoNoName: "Découvre à quel point tes amis te connaissent 👇",
      endFomoGame: "Joue à ça et à d'autres jeux avec tes amis 👇",
      continuePlaying: "Continuer à jouer",
      cou: {
        title: "Test de Couple",
        description: (name) => `Tu ferais mieux de ne pas gâcher ça !`
      },
      tot: {
        title: "Ceci ou Cela ?",
        description: (name) => `À quel point connais-tu ${name} ?`
      },
      sib: {
        title: "Test entre Frères et Sœurs",
        description: (name) => `À quel point vous connaissez-vous ?`
      },
      playQuiz: "Jouer au quiz",
      leaderboardSub: (name) => `Qui connaît ${name} le mieux ?`,
      resTitle: (score) => `${score} sur 10 correctes`,
      resDes: (name) => `Crée ton propre quiz maintenant.`,
      ranking: "Classement",
      newQuiz: (name) => `${name} a de nouvelles questions ❗️`,
      qreslock: "Crée d’abord ton propre quiz pour voir ce que tu as raté !",
      endFomoBadScore: "Tu penses que tes amis te connaissent mieux ? 👇",
      endFomoGoodScore: "Tu penses que tes amis te connaissent aussi bien ? 👇",
      endFomoQuestions: "Vois quelles questions tu as ratées 👀",
      justGuess: "Devine",
      testYourFriends: "Teste tes amis",
      resultCopyLink: "Copie ce lien et colle-le dans l’app pour voir les questions ratées 👇",
      getTheApp: "Voir le résultat",
      linkCopied: "Lien copié !",
      customHint: (name) => `Question créée par ${name}`,
      loadingQuiz: "Chargement du quiz...",
      loadingResult: "Chargement du résultat...",
    },

    ar: {
      joinApp: {
        fat: "أنشئ اختبارك الخاص في تطبيقنا",
        text: "واكتشف مدى معرفة أصدقائك بك ⬇️"
      },
      privacy: "سياسة الخصوصية",
      terms: "شروط الاستخدام",
      invalidLink: {
        title: "رابط الاختبار غير صالح",
        text: "تحقق من الرابط أو حاول مرة أخرى باستخدام التطبيق."
      },
      incognitoMode: {
        title: "ميزة الاختبار محظورة",
        text: "قد لا تعمل بعض الميزات في وضع التصفح المتخفي. جرّب فتح الرابط في الوضع العادي."
      },
      quizCompleted: {
        title: "اكتمل الاختبار",
        text: (name) => `يمكن لـ ${name} الاطلاع على إجاباتك في التطبيق.`
      },
      you: "أنت",
      yourFriend: "صديقك",
      quizOwner: (name) => `اختبار ${name}`,
      enterName: {
        title: "ما اسمك؟",
        text: (name) => `أدخل اسمك ليعرف ${name} أن هذه الإجابات لك.`
      },
      limitReached: {
        title: "تم الوصول إلى حد الاختبارات",
        text: (name) => `لقد وصل ${name} إلى الحد الأقصى للأصدقاء.`
      },
      startDescription: (name) => `ما مدى معرفتك بـ ${name}؟`,
      popupText: "أنشئ اختبارك الخاص في تطبيق BondZ ⬇️",
      createQuiz: {
        short: "أنشئ اختبارك",
        long: "أنشئ اختبارك الخاص"
      },
      popupFomo: {
        text: (name) => `قام ${name} والعديد من الآخرين بإنشاء اختبارهم بالفعل `,
        fat: "👇 الآن دورك 👇"
      },
      popupDes: "ما مدى معرفة أصدقائك بك؟",
      message1: (name) => `يمكن لـ ${name} رؤية إجاباتك في التطبيق 📲`,
      message2: "واصل التقدم 👏",
      message3: "أنت في منتصف الطريق 🥳",
      message4: "شارفت على الانتهاء 👀\nتبقّى سؤالان فقط!",
      questionCount: (count) => `السؤال ${count} من 10`,
      startQuiz: "ابدأ الاختبار",
      loadingQuiz: "جارٍ تحميل الأسئلة...",
      gameCompleted: {
        title: "اكتملت اللعبة",
        text: (name) => `يمكن لـ ${name} مراجعة إجاباتك الآن. اطلب النتيجة من ${name}.`
      },
      woy: {
        title: "من منكما؟",
        description: (name) => `العب "من منكما؟" مع ${name}`
      },
      tel: {
        title: "التخاطر بالإيموجي",
        description: (name) => `حاول اختيار نفس الإيموجي مثل ${name}`
      },
      notUnlocked: {
        title: "وضع اللعبة مقفل",
        text: (name) => `لم يقم ${name} بفتح وضع اللعبة هذا بعد.`
      },
      startFomo: (name) => `👇 أجب عن 10 أسئلة سريعة عن ${name}`,
      startFomoCount: (count, name) => `👇 ${count} من أصدقاء ${name} شاركوا في هذا الاختبار`,
      endFomo: (name) => `👇 اكتشف مدى معرفة ${name} وبقية أصدقائك بك`,
      endFomoFriends: (name) => `👇 اكتشف مدى معرفة ${name} وأصدقائك بك`,
      endFomoNoName: "👇 اكتشف مدى معرفة أصدقائك بك",
      endFomoGame: "👇 العب هذه اللعبة وألعابًا أخرى مع أصدقائك",
      continuePlaying: "تابع اللعب",
      cou: {
        title: "اختبار الأزواج",
        description: (name) => `من الأفضل ألا تفسد الأمر!`
      },
      tot: {
        title: "هذا أم ذاك؟",
        description: (name) => `إلى أي مدى تعرف ${name}؟`
      },
      sib: {
        title: "اختبار الإخوة",
        description: (name) => `إلى أي مدى تعرفان بعضكما البعض؟`
      },
      playQuiz: "العب الاختبار",
      leaderboardSub: (name) => `من يعرف ${name} أكثر؟`,
      resTitle: (score) => `${score} من 10 صحيحة`,
      resDes: (name) => `أنشئ اختبارك الخاص الآن وأرسله إلى ${name}`,
      ranking: "الترتيب",
      newQuiz: (name) => `لدى ${name} أسئلة جديدة ❗️`,
      qreslock: "أنشئ اختبارك أولاً لترى ما أخطأت فيه!",
      endFomoBadScore: "تعتقد أن أصدقاءك يعرفونك أفضل؟ 👇",
      endFomoGoodScore: "هل تعتقد أن أصدقاءك يعرفونك بهذا القدر أيضًا؟ 👇",
      endFomoQuestions: "شاهد الأسئلة التي أخطأت فيها 👀",
      justGuess: "فقط خمن",
      testYourFriends: "اختبر أصدقاءك",
      resultCopyLink: "انسخ هذا الرابط والصقه في التطبيق لترى الأسئلة التي أخطأت فيها 👇",
      getTheApp: "عرض النتيجة",
      linkCopied: "تم نسخ الرابط!",
      customHint: (name) => `تم إنشاء السؤال بواسطة ${name}`,
      loadingQuiz: "جارٍ تحميل الاختبار...",
      loadingResult: "جارٍ تحميل النتيجة...",
    },
    
    ja: {
      joinApp: {
        fat: "アプリで自分だけのクイズを作ろう",
        text: "友だちがどれだけあなたを知っているかチェック ⬇️"
      },
      privacy: "プライバシーポリシー",
      terms: "利用規約",
      invalidLink: {
        title: "無効なクイズリンク",
        text: "リンクを確認するか、アプリでもう一度試してください。"
      },
      incognitoMode: {
        title: "クイズ機能が制限されています",
        text: "シークレットモードでは一部の機能が使えない場合があります。通常モードで開いてみてください。"
      },
      quizCompleted: {
        title: "クイズ完了",
        text: (name) => `${name}はアプリであなたの回答を確認できます。`
      },
      you: "あなた",
      yourFriend: "友だち",
      quizOwner: (name) => `${name}のクイズ`,
      enterName: {
        title: "名前は？",
        text: (name) => `${name}があなたの回答だと分かるように名前を入力してください。`
      },
      limitReached: {
        title: "クイズ上限に達しました",
        text: (name) => `${name}は友だちの上限に達しました。`
      },
      startDescription: (name) => `${name}のこと、どれくらい知ってる？`,
      popupText: "BondZアプリで自分のクイズを作ろう ⬇️",
      createQuiz: {
        short: "クイズを作成",
        long: "自分だけのクイズを作成"
      },
      popupFomo: {
        text: (name) => `${name}を含む多くの人がすでにクイズを作成しています `,
        fat: "👇 次はあなた 👇"
      },
      popupDes: "友だちはあなたをどれくらい知ってる？",
      message1: (name) => `${name}はアプリであなたの回答を見ることができます 📲`,
      message2: "この調子でいこう 👏",
      message3: "半分まで来たよ 🥳",
      message4: "もうすぐ完了 👀\nあと2問！",
      questionCount: (count) => `全10問中 ${count}問目`,
      startQuiz: "クイズ開始",
      loadingQuiz: "質問を読み込み中...",
      gameCompleted: {
        title: "ゲーム完了",
        text: (name) => `結果は${name}に聞いてください。`
      },
      woy: {
        title: "どっち？",
        description: (name) => `${name}と「どっち？」をプレイ`
      },
      tel: {
        title: "絵文字テレパシー",
        description: (name) => `${name}と同じ絵文字を選んでみよう`
      },
      notUnlocked: {
        title: "ゲームモードがロックされています",
        text: (name) => `${name}はまだこのゲームモードを解除していません。`
      },
      startFomo: (name) => `${name}についての簡単な10問に答えよう 👇`,
      startFomoCount: (count, name) => `${name}の友だち${count}人がすでに参加しています 👇`,
      endFomo: (name) => `${name}や他の友だちがどれだけあなたを知っているか確認しよう 👇`,
      endFomoFriends: (name) => `${name}や友だちがどれだけあなたを知っているか確認しよう 👇`,
      endFomoNoName: "友だちがどれだけあなたを知っているか確認しよう 👇",
      endFomoGame: "友だちとこのゲームや他のゲームで遊ぼう 👇",
      continuePlaying: "プレイを続ける",
      cou: {
        title: "カップルテスト",
        description: (name) => `絶対に失敗しないでね！`
      },
      tot: {
        title: "どっち？",
        description: (name) => `${name}のことをどれくらい知ってる？`
      },
      sib: {
        title: "兄弟姉妹テスト",
        description: (name) => `お互いのことをどれくらい知っている？`
      },
      playQuiz: "クイズをプレイ",
      leaderboardSub: (name) => `${name}のことを一番よく知っているのは誰？`,
      resTitle: (score) => `10問中${score}問正解`,
      resDes: (name) => `今すぐ自分だけのクイズを作成して${name}に送ろう`,
      ranking: "ランキング",
      newQuiz: (name) => `${name}に新しい質問があります ❗️`,
      qreslock: "何を間違えたか見るにはまず自分のクイズを作ろう！",
      endFomoBadScore: "友達の方がもっとあなたを知ってると思う？👇",
      endFomoGoodScore: "友達もあなたをこれくらいよく知ってると思う？👇",
      endFomoQuestions: "どの問題を間違えたか見てみよう 👀",
      justGuess: "当てて",
      testYourFriends: "友達を試そう",
      resultCopyLink: "このリンクをコピーしてアプリに貼り付けると、間違えた問題が見られるよ 👇",
      getTheApp: "結果を見る",
      linkCopied: "リンクをコピーしました！",
      customHint: (name) => `${name}さんが作成した質問`,
      loadingQuiz: "クイズを読み込み中...",
      loadingResult: "結果を読み込み中...",
    },

    ko: {
      joinApp: {
        fat: "앱에서 나만의 퀴즈를 만들어보세요",
        text: "친구들이 당신을 얼마나 잘 아는지 알아보세요 ⬇️"
      },
      privacy: "개인정보 처리방침",
      terms: "이용약관",
      invalidLink: {
        title: "유효하지 않은 퀴즈 링크",
        text: "링크를 확인하거나 앱에서 다시 시도해 주세요."
      },
      incognitoMode: {
        title: "퀴즈 기능이 차단되었습니다",
        text: "시크릿 모드에서는 일부 기능이 작동하지 않을 수 있습니다. 일반 모드에서 링크를 열어보세요."
      },
      quizCompleted: {
        title: "퀴즈 완료",
        text: (name) => `${name}님은 앱에서 당신의 답변을 확인할 수 있습니다.`
      },
      you: "나",
      yourFriend: "친구",
      quizOwner: (name) => `${name}의 퀴즈`,
      enterName: {
        title: "이름이 무엇인가요?",
        text: (name) => `${name}이(가) 이 답변이 당신의 것임을 알 수 있도록 이름을 입력하세요.`
      },
      limitReached: {
        title: "퀴즈 제한 도달",
        text: (name) => `${name}님은 친구 수 제한에 도달했습니다.`
      },
      startDescription: (name) => `${name}에 대해 얼마나 잘 알고 있나요?`,
      popupText: "BondZ 앱에서 나만의 퀴즈를 만들어보세요 ⬇️",
      createQuiz: {
        short: "퀴즈 만들기",
        long: "나만의 퀴즈 만들기"
      },
      popupFomo: {
        text: (name) => `${name}님과 많은 사람들이 이미 퀴즈를 만들었습니다 `,
        fat: "👇 이제 당신 차례예요 👇"
      },
      popupDes: "친구들은 당신을 얼마나 잘 알고 있을까요?",
      message1: (name) => `${name}님은 앱에서 당신의 답변을 볼 수 있습니다 📲`,
      message2: "계속 진행하세요 👏",
      message3: "절반까지 왔어요 🥳",
      message4: "거의 끝났어요 👀\n이제 2문제 남았어요!",
      questionCount: (count) => `10문제 중 ${count}번`,
      startQuiz: "퀴즈 시작",
      loadingQuiz: "질문 불러오는 중...",
      gameCompleted: {
        title: "게임 완료",
        text: (name) => `결과는 ${name}님에게 물어보세요.`
      },
      woy: {
        title: "우리 중 누구?",
        description: (name) => `${name}와 함께 '우리 중 누구?' 플레이`
      },
      tel: {
        title: "이모지 텔레파시",
        description: (name) => `${name}와 같은 이모지를 골라보세요`
      },
      notUnlocked: {
        title: "게임 모드 잠김",
        text: (name) => `${name}님은 아직 이 게임 모드를 잠금 해제하지 않았습니다.`
      },
      startFomo: (name) => `${name}에 대한 10개의 빠른 질문에 답하세요 👇`,
      startFomoCount: (count, name) => `${name}의 친구 ${count}명이 이미 이 퀴즈를 완료했습니다 👇`,
      endFomo: (name) => `${name}와 다른 친구들이 당신을 얼마나 잘 아는지 확인해 보세요 👇`,
      endFomoFriends: (name) => `${name}와 친구들이 당신을 얼마나 잘 아는지 확인해 보세요 👇`,
      endFomoNoName: "친구들이 당신을 얼마나 잘 아는지 확인해 보세요 👇",
      endFomoGame: "친구들과 이 게임과 다른 게임들을 즐겨보세요 👇",
      continuePlaying: "계속 플레이하기",
      cou: {
        title: "커플 테스트",
        description: (name) => `이건 절대 망치지 마!`
      },
      tot: {
        title: "이거 아니면 저거?",
        description: (name) => `${name}을(를) 얼마나 잘 알고 있어?`
      },
      sib: {
        title: "형제자매 테스트",
        description: (name) => `서로를 얼마나 잘 알고 있나요?`
      },
      playQuiz: "퀴즈 플레이",
      leaderboardSub: (name) => `${name}을(를) 가장 잘 아는 사람은 누구?`,
      resTitle: (score) => `10 üzerinden ${score} doğru`,
      resDes: (name) => `지금 나만의 퀴즈를 만들고 ${name}에게 보내세요`,
      ranking: "랭킹",
      newQuiz: (name) => `${name}님이 새로운 질문을 추가했어요 ❗️`,
      qreslock: "결과를 보려면 먼저 나만의 퀴즈를 만들어보세요 👀",
      qreslock: "틀린 문제를 보려면 먼저 나만의 퀴즈를 만들어보세요!",
      endFomoBadScore: "친구들이 너를 더 잘 안다고 생각해? 👇",
      endFomoGoodScore: "친구들도 너를 이만큼 잘 안다고 생각해? 👇",
      endFomoQuestions: "틀린 문제를 확인해보세요 👀",
      justGuess: "그냥 맞혀봐",
      testYourFriends: "친구들을 테스트해봐",
      resultCopyLink: "이 링크를 복사해서 앱에 붙여넣으면 틀린 문제를 볼 수 있어요 👇",
      getTheApp: "결과 보기",
      linkCopied: "링크가 복사되었습니다!",
      customHint: (name) => `${name}님이 만든 질문`,
      loadingQuiz: "퀴즈 불러오는 중...",
      loadingResult: "결과 불러오는 중...",
    },
    
    tr: {
      joinApp: {
        fat: "Uygulamamızda kendi testini oluştur",
        text: "ve arkadaşlarının seni ne kadar iyi tanıdığını öğren ⬇️"
      },
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Şartları",
      invalidLink: {
        title: "Geçersiz Test Bağlantısı",
        text: "Bağlantıyı kontrol et veya uygulamayla tekrar dene."
      },
      incognitoMode: {
        title: "Test Özelliği Engellendi",
        text: "Gizli modda bazı özellikler çalışmayabilir. Bağlantıyı normal modda açmayı dene."
      },
      quizCompleted: {
        title: "Test Tamamlandı",
        text: (name) => `${name}, cevaplarını uygulamada görebilir.`
      },
      you: "Sen",
      yourFriend: "Arkadaşın",
      quizOwner: (name) => `${name}'in Testi`,
      enterName: {
        title: "Adın ne?",
        text: (name) => `Cevapların sana ait olduğunu ${name}'in bilmesi için adını gir.`
      },
      limitReached: {
        title: "Test Limiti Doldu",
        text: (name) => `${name}, arkadaş limitine ulaştı.`
      },
      startDescription: (name) => `${name}'i ne kadar iyi tanıyorsun?`,
      popupText: "BondZ Uygulamasında kendi testini oluştur ⬇️",
      createQuiz: {
        short: "Test oluştur",
        long: "Kendi testini oluştur"
      },
      popupFomo: {
        text: (name) => `${name} ve daha birçok kişi testini zaten oluşturdu `,
        fat: "👇 Şimdi sıra sende 👇"
      },
      popupDes: "Arkadaşların seni ne kadar iyi tanıyor?",
      message1: (name) => `${name}, cevaplarını uygulamada görebilir 📲`,
      message2: "Devam et 👏",
      message3: "Yolun yarısındasın 🥳",
      message4: "Neredeyse bitti 👀\nSadece 2 soru kaldı!",
      questionCount: (count) => `10 sorudan ${count}. soru`,
      startQuiz: "Teste Başla",
      loadingQuiz: "Sorular yükleniyor...",
      gameCompleted: {
        title: "Oyun Tamamlandı",
        text: (name) => `Sonucu ${name}'den iste.`
      },
      woy: {
        title: "Hanginiz?",
        description: (name) => `${name} ile 'Hanginiz?' oyna`
      },
      tel: {
        title: "Emoji Telepatisi",
        description: (name) => `${name} ile aynı emojileri seçmeye çalış`
      },
      notUnlocked: {
        title: "Oyun Modu Kilitli",
        text: (name) => `${name} bu oyun modunu henüz açmadı.`
      },
      startFomo: (name) => `${name} hakkında 10 hızlı soruyu cevapla 👇`,
      startFomoCount: (count, name) => `${name}'in ${count} arkadaşı bu testi zaten yaptı 👇`,
      endFomo: (name) => `${name} ve diğer arkadaşlarının seni ne kadar iyi tanıdığını öğren 👇`,
      endFomoFriends: (name) => `${name} ve arkadaşlarının seni ne kadar iyi tanıdığını öğren 👇`,
      endFomoNoName: "Arkadaşlarının seni ne kadar iyi tanıdığını öğren 👇",
      endFomoGame: "Bunu ve diğer oyunları arkadaşlarınla oyna 👇",
      continuePlaying: "Oynamaya devam et",
      cou: {
        title: "Çift Testi",
        description: (name) => `Bunu mahvetmesen iyi olur!`
      },
      tot: {
        title: "Bu mu Şu mu?",
        description: (name) => `${name}'i ne kadar iyi tanıyorsun?`
      },
      sib: {
        title: "Kardeş Testi",
        description: (name) => `Birbirinizi ne kadar iyi tanıyorsunuz?`
      },
      playQuiz: "Quiz oyna",
      leaderboardSub: (name) => `${name}'i en iyi kim tanıyor?`,
      resTitle: (score) => `10 üzerinden ${score} doğru`,
      resDes: (name) => `Kendi quizini şimdi oluştur.`,
      ranking: "Sıralama",
      newQuiz: (name) => `${name} yeni sorulara sahip ❗️`,
      qreslock: "Ne yanlış yaptığını görmek için önce kendi quizini oluştur!",
      endFomoBadScore: "Sence arkadaşların seni daha iyi tanıyor mu? 👇",
      endFomoGoodScore: "Sence arkadaşların da seni bu kadar iyi tanıyor mu? 👇",
      endFomoQuestions: "Hangi soruları yanlış yaptığını gör 👀",
      justGuess: "Sadece tahmin et",
      testYourFriends: "Arkadaşlarını test et",
      resultCopyLink: "Hangi soruları yanlış yaptığını görmek için bu bağlantıyı kopyalayıp uygulamaya yapıştır 👇",
      getTheApp: "Sonucu gör",
      linkCopied: "Bağlantı kopyalandı!",
      customHint: (name) => `Soru ${name} tarafından oluşturuldu`,
      loadingQuiz: "Quiz yükleniyor...",
      loadingResult: "Sonuç yükleniyor...",
    },
    
    it: {
      joinApp: {
        fat: "Crea il tuo quiz nella nostra app",
        text: "e scopri quanto i tuoi amici ti conoscono ⬇️"
      },
      privacy: "Informativa sulla Privacy",
      terms: "Termini di Utilizzo",
      invalidLink: {
        title: "Link del Quiz non valido",
        text: "Controlla il link o riprova con l'app."
      },
      incognitoMode: {
        title: "Funzione Quiz Bloccata",
        text: "Alcune funzioni potrebbero non funzionare in modalità in incognito. Prova ad aprire il link in modalità normale."
      },
      quizCompleted: {
        title: "Quiz Completato",
        text: (name) => `${name} può vedere le tue risposte nell'app.`
      },
      you: "Tu",
      yourFriend: "Il tuo amico",
      quizOwner: (name) => `Quiz di ${name}`,
      enterName: {
        title: "Come ti chiami?",
        text: (name) => `Inserisci il tuo nome così ${name} saprà che queste risposte sono le tue.`
      },
      limitReached: {
        title: "Limite del Quiz Raggiunto",
        text: (name) => `${name} ha raggiunto il limite di amici.`
      },
      startDescription: (name) => `Quanto conosci ${name}?`,
      popupText: "Crea il tuo quiz nell'app BondZ ⬇️",
      createQuiz: {
        short: "Crea quiz",
        long: "Crea il tuo quiz"
      },
      popupFomo: {
        text: (name) => `${name} e molti altri hanno già creato il loro quiz `,
        fat: "👇 Ora tocca a te 👇"
      },
      popupDes: "Quanto ti conoscono i tuoi amici?",
      message1: (name) => `${name} può vedere le tue risposte nell'app 📲`,
      message2: "Continua così 👏",
      message3: "Sei a metà strada 🥳",
      message4: "Quasi finito 👀\nSolo altre 2 domande!",
      questionCount: (count) => `Domanda ${count} su 10`,
      startQuiz: "Inizia Quiz",
      loadingQuiz: "Caricamento domande...",
      gameCompleted: {
        title: "Gioco Completato",
        text: (name) => `Chiedi il risultato a ${name}.`
      },
      woy: {
        title: "Chi di voi?",
        description: (name) => `Gioca a "Chi di voi?" con ${name}`
      },
      tel: {
        title: "Telepatia con Emoji",
        description: (name) => `Prova a scegliere le stesse emoji di ${name}`
      },
      notUnlocked: {
        title: "Modalità di Gioco Bloccata",
        text: (name) => `${name} non ha ancora sbloccato questa modalità di gioco.`
      },
      startFomo: (name) => `Rispondi a 10 domande veloci su ${name} 👇`,
      startFomoCount: (count, name) => `${count} amici di ${name} hanno già fatto questo quiz 👇`,
      endFomo: (name) => `Scopri quanto ${name} e gli altri amici ti conoscono 👇`,
      endFomoFriends: (name) => `Scopri quanto ${name} e i tuoi amici ti conoscono 👇`,
      endFomoNoName: "Scopri quanto ti conoscono i tuoi amici 👇",
      endFomoGame: "Gioca a questo e ad altri giochi con i tuoi amici 👇",
      continuePlaying: "Continua a giocare",
      cou: {
        title: "Test di Coppia",
        description: (name) => `Meglio non mandare tutto all'aria!`
      },
      tot: {
        title: "Questo o Quello?",
        description: (name) => `Quanto conosci ${name}?`
      },
      sib: {
        title: "Test tra Fratelli e Sorelle",
        description: (name) => `Quanto vi conoscete?`
      },
      playQuiz: "Gioca al quiz",
      leaderboardSub: (name) => `Chi conosce meglio ${name}?`,
      resTitle: (score) => `${score} su 10 corrette`,
      resDes: (name) => `Crea il tuo quiz ora.`,
      ranking: "Classifica",
      newQuiz: (name) => `${name} ha nuove domande ❗️`,
      qreslock: "Crea prima il tuo quiz per vedere cosa hai sbagliato!",
      endFomoBadScore: "Pensi che i tuoi amici ti conoscano meglio? 👇",
      endFomoGoodScore: "Pensi che i tuoi amici ti conoscano anche così bene? 👇",
      endFomoQuestions: "Scopri quali domande hai sbagliato 👀",
      justGuess: "Indovina",
      testYourFriends: "Sfida gli amici",
      resultCopyLink: "Copia questo link e incollalo nell’app per vedere quali domande hai sbagliato 👇",
      getTheApp: "Vedi il risultato",
      linkCopied: "Link copiato!",
      customHint: (name) => `Domanda creata da ${name}`,
      loadingQuiz: "Caricamento del quiz...",
      loadingResult: "Caricamento del risultato...",
    },
    
    id: {
      joinApp: {
        fat: "Buat kuismu sendiri di aplikasi kami",
        text: "dan cari tahu seberapa baik teman-temanmu mengenalmu ⬇️"
      },
      privacy: "Kebijakan Privasi",
      terms: "Syarat Penggunaan",
      invalidLink: {
        title: "Tautan Kuis Tidak Valid",
        text: "Periksa tautan atau coba lagi melalui aplikasi."
      },
      incognitoMode: {
        title: "Fitur Kuis Diblokir",
        text: "Beberapa fitur mungkin tidak berfungsi dalam mode penyamaran. Coba buka tautan dalam mode normal."
      },
      quizCompleted: {
        title: "Kuis Selesai",
        text: (name) => `${name} dapat melihat jawabanmu di aplikasi.`
      },
      you: "Kamu",
      yourFriend: "Temanmu",
      quizOwner: (name) => `Kuis ${name}`,
      enterName: {
        title: "Siapa namamu?",
        text: (name) => `Masukkan namamu agar ${name} tahu jawaban ini milikmu.`
      },
      limitReached: {
        title: "Batas Kuis Tercapai",
        text: (name) => `${name} telah mencapai batas teman.`
      },
      startDescription: (name) => `Seberapa baik kamu mengenal ${name}?`,
      popupText: "Buat kuismu sendiri di aplikasi BondZ ⬇️",
      createQuiz: {
        short: "Buat kuis",
        long: "Buat kuismu sendiri"
      },
      popupFomo: {
        text: (name) => `${name} dan banyak lainnya sudah membuat kuis mereka `,
        fat: "👇 Sekarang giliranmu 👇"
      },
      popupDes: "Seberapa baik teman-temanmu mengenalmu?",
      message1: (name) => `${name} dapat melihat jawabanmu di aplikasi 📲`,
      message2: "Lanjutkan 👏",
      message3: "Kamu sudah setengah jalan 🥳",
      message4: "Hampir selesai 👀\nTinggal 2 pertanyaan lagi!",
      questionCount: (count) => `Pertanyaan ${count} dari 10`,
      startQuiz: "Mulai Kuis",
      loadingQuiz: "Memuat pertanyaan...",
      gameCompleted: {
        title: "Permainan Selesai",
        text: (name) => `Minta hasilnya dari ${name}.`
      },
      woy: {
        title: "Siapa di Antara Kalian?",
        description: (name) => `Mainkan "Siapa di Antara Kalian?" bersama ${name}`
      },
      tel: {
        title: "Telepati Emoji",
        description: (name) => `Coba pilih emoji yang sama dengan ${name}`
      },
      notUnlocked: {
        title: "Mode Permainan Terkunci",
        text: (name) => `${name} belum membuka mode permainan ini.`
      },
      startFomo: (name) => `Jawab 10 pertanyaan cepat tentang ${name} 👇`,
      startFomoCount: (count, name) => `${count} teman ${name} sudah mengikuti kuis ini 👇`,
      endFomo: (name) => `Cari tahu seberapa baik ${name} dan teman-temanmu mengenalmu 👇`,
      endFomoFriends: (name) => `Cari tahu seberapa baik ${name} dan teman-temanmu mengenalmu 👇`,
      endFomoNoName: "Cari tahu seberapa baik teman-temanmu mengenalmu 👇",
      endFomoGame: "Mainkan ini dan game lainnya bersama teman-temanmu 👇",
      continuePlaying: "Lanjut bermain",
      cou: {
        title: "Tes Pasangan",
        description: (name) => `Sebaiknya jangan sampai kamu mengacaukannya!`
      },
      tot: {
        title: "Ini atau Itu?",
        description: (name) => `Seberapa baik kamu mengenal ${name}?`
      },
      sib: {
        title: "Tes Saudara",
        description: (name) => `Seberapa baik kalian saling mengenal?`
      },
      playQuiz: "Mainkan kuis",
      leaderboardSub: (name) => `Siapa yang paling mengenal ${name}?`,
      resTitle: (score) => `${score} dari 10 benar`,
      resDes: (name) => `Buat kuismu sendiri sekarang.`,
      ranking: "Peringkat",
      newQuiz: (name) => `${name} punya pertanyaan baru ❗️`,
      qreslock: "Buat dulu kuismu untuk melihat apa yang salah!",
      endFomoBadScore: "Yakin temanmu mengenalmu lebih baik? 👇",
      endFomoGoodScore: "Yakin temanmu juga mengenalmu sebaik ini? 👇",
      endFomoQuestions: "Lihat pertanyaan yang kamu salah 👀",
      justGuess: "Tebak saja",
      testYourFriends: "Uji temanmu",
      resultCopyLink: "Salin link ini dan tempel di aplikasi untuk melihat soal yang salah 👇",
      getTheApp: "Lihat hasil",
      linkCopied: "Tautan disalin!",
      customHint: (name) => `Pertanyaan dibuat oleh ${name}`,
      loadingQuiz: "Memuat kuis...",
      loadingResult: "Memuat hasil...",
    },
    
    ru: {
      joinApp: {
        fat: "Создай свой собственный квиз в нашем приложении",
        text: "и узнай, насколько хорошо тебя знают друзья ⬇️"
      },
      privacy: "Политика конфиденциальности",
      terms: "Условия использования",
      invalidLink: {
        title: "Недействительная ссылка на квиз",
        text: "Проверь ссылку или попробуй снова через приложение."
      },
      incognitoMode: {
        title: "Функция квиза заблокирована",
        text: "Некоторые функции могут не работать в режиме инкогнито. Попробуй открыть ссылку в обычном режиме."
      },
      quizCompleted: {
        title: "Квиз завершён",
        text: (name) => `${name} может посмотреть твои ответы в приложении.`
      },
      you: "Ты",
      yourFriend: "Твой друг",
      quizOwner: (name) => `Квиз ${name}`,
      enterName: {
        title: "Как тебя зовут?",
        text: (name) => `Введи своё имя, чтобы ${name} знал(а), что эти ответы твои.`
      },
      limitReached: {
        title: "Достигнут лимит квиза",
        text: (name) => `${name} достиг(ла) лимита друзей.`
      },
      startDescription: (name) => `Насколько хорошо ты знаешь ${name}?`,
      popupText: "Создай свой квиз в приложении BondZ ⬇️",
      createQuiz: {
        short: "Создать квиз",
        long: "Создать свой квиз"
      },
      popupFomo: {
        text: (name) => `${name} и многие другие уже создали свой квиз `,
        fat: "👇 Теперь твоя очередь 👇"
      },
      popupDes: "Насколько хорошо друзья тебя знают?",
      message1: (name) => `${name} может увидеть твои ответы в приложении 📲`,
      message2: "Продолжай 👏",
      message3: "Ты уже на полпути 🥳",
      message4: "Почти готово 👀\nОсталось всего 2 вопроса!",
      questionCount: (count) => `Вопрос ${count} из 10`,
      startQuiz: "Начать квиз",
      loadingQuiz: "Загрузка вопросов...",
      gameCompleted: {
        title: "Игра завершена",
        text: (name) => `Узнайте результат у ${name}.`
      },
      woy: {
        title: "Кто из вас?",
        description: (name) => `Сыграй в «Кто из вас?» с ${name}`
      },
      tel: {
        title: "Телепатия с эмодзи",
        description: (name) => `Попробуй выбрать те же эмодзи, что и ${name}`
      },
      notUnlocked: {
        title: "Режим игры заблокирован",
        text: (name) => `${name} ещё не разблокировал(а) этот режим игры.`
      },
      startFomo: (name) => `Ответь на 10 быстрых вопросов о ${name} 👇`,
      startFomoCount: (count, name) => `${count} друзей ${name} уже прошли этот квиз 👇`,
      endFomo: (name) => `Узнай, насколько хорошо ${name} и другие друзья тебя знают 👇`,
      endFomoFriends: (name) => `Узнай, насколько хорошо ${name} и твои друзья тебя знают 👇`,
      endFomoNoName: "Узнай, насколько хорошо друзья тебя знают 👇",
      endFomoGame: "Играй в это и другие игры с друзьями 👇",
      continuePlaying: "Продолжить играть",
      cou: {
        title: "Тест для пары",
        description: (name) => `Лучше тебе это не запороть!`
      },
      tot: {
        title: "Это или то?",
        description: (name) => `Насколько хорошо ты знаешь ${name}?`
      },
      sib: {
        title: "Тест для братьев и сестёр",
        description: (name) => `Насколько хорошо вы знаете друг друга?`
      },
      playQuiz: "Играть в квиз",
      leaderboardSub: (name) => `Кто лучше всех знает ${name}?`,
      resTitle: (score) => `${score} из 10 правильных`,
      resDes: (name) => `Создай свою викторину прямо сейчас.`,
      ranking: "Рейтинг",
      newQuiz: (name) => `${name} добавил новые вопросы ❗️`,
      qreslock: "Сначала создай свой квиз, чтобы увидеть, что ты сделал неправильно!",
      endFomoBadScore: "Думаешь, друзья знают тебя лучше? 👇",
      endFomoGoodScore: "Думаешь, друзья тоже знают тебя так хорошо? 👇",
      endFomoQuestions: "Посмотри, какие вопросы ты сделал неправильно 👀",
      justGuess: "Просто угадай",
      testYourFriends: "Проверь своих друзей",
      resultCopyLink: "Скопируй эту ссылку и вставь её в приложение, чтобы увидеть, какие вопросы ты ответил неправильно 👇",
      getTheApp: "Посмотреть результат",
      linkCopied: "Ссылка скопирована!",
      customHint: (name) => `Вопрос создан пользователем ${name}`,
      loadingQuiz: "Загрузка викторины...",
      loadingResult: "Загрузка результата...",
    },
    
  };

  export default translations;